import { Menu, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import * as HIcons from "react-icons/hi";
import { Link } from 'react-router-dom';
import nav from '../JSON/NavFoot';

export default function Collapsebar() {
  return (
    <div className="w-16">
      <Menu as="div" className="relative inline-block font-semibold">
        <div>
          <Menu.Button className="inline-flex w-full justify-center rounded-md bg-black bg-opacity-20 px-4 py-2 text-sm font-medium text-white hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <HIcons.HiMenu
              className="h-5 w-5 text-violet-200 hover:text-violet-100"
              aria-hidden="true"
            />
          </Menu.Button>
        </div>
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className="absolute left-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div className="px-1 py-1 ">
              <Menu.Item>
                {({ active }) => (
                  <Link to={nav[0].link}>
                    <button
                      className={`${active ? 'bg-[#101242] text-white transition-all duration-200' : 'text-gray-900 transition-all duration-200'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      {active ? (
                        <HIcons.HiHome
                          className="mr-2 h-5 w-5 text-[#F4DC7C]"
                          aria-hidden="true"
                        />
                      ) : (
                        <HIcons.HiHome
                          className="mr-2 h-5 w-5 text-[#ed5955]"
                          aria-hidden="true"
                        />
                      )}
                      {nav[0].title}
                    </button>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link to={nav[1].link}>
                    <button
                      className={`${active ? 'bg-[#101242] text-white transition-all duration-200' : 'text-gray-900 transition-all duration-200'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      {active ? (
                        <HIcons.HiUser
                          className="mr-2 h-5 w-5 text-[#F4DC7C]"
                          aria-hidden="true"
                        />
                      ) : (
                        <HIcons.HiUser
                          className="mr-2 h-5 w-5 text-[#ed5955]"
                          aria-hidden="true"
                        />
                      )}
                      {nav[1].title}
                    </button>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <Link to={nav[2].link}>
                  <button
                    className={`${active ? 'bg-[#101242] text-white transition-all duration-200' : 'text-gray-900 transition-all duration-200'
                      } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                  >
                    {active ? (
                      <HIcons.HiCalendar
                        className="mr-2 h-5 w-5 text-[#F4DC7C]"
                        aria-hidden="true"
                      />
                    ) : (
                      <HIcons.HiCalendar
                        className="mr-2 h-5 w-5 text-[#ed5955]"
                        aria-hidden="true"
                      />
                    )}
                      {nav[2].title}
                  </button>
                  </Link>
                )}
              </Menu.Item>
              <Menu.Item>
                {({ active }) => (
                  <a target='_blank' rel='noreferrer' href={nav[3].link}>
                    <button
                      className={`${active ? 'bg-[#101242] text-white transition-all duration-200' : 'text-gray-900 transition-all duration-200'
                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                    >
                      {active ? (
                        <HIcons.HiUserGroup
                          className="mr-2 h-5 w-5 text-[#F4DC7C]"
                          aria-hidden="true"
                        />
                      ) : (
                        <HIcons.HiUserGroup
                          className="mr-2 h-5 w-5 text-[#ed5955]"
                          aria-hidden="true"
                        />
                      )}
                      {nav[3].title}
                    </button>
                  </a>
                )}
              </Menu.Item>
            </div>
          </Menu.Items>
        </Transition>
      </Menu>
    </div>
  )
}
